import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { gql, useMutation } from '@apollo/client';

const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, senha: $password) {
      token
      usuario {
        id
        nome
        email
        username
        atleta {
          id
        }
        organizadores {
          id
          liga {
            id
            nome
            imagemUrl
          }
          torneio {
            id
            nome
          }

        }
        imagemUrl
        role
      }
    }
  }
`;

const REGISTER_MUTATION = gql`
  mutation Register($name: String!, $email: String!, $password: String!) {
    register(name: $name, email: $email, senha: $password) {
      token
      usuario {
        id
        nome
        email
        role
        atleta {
          id
        }
      }
    }
  }
`;

interface AuthContextProps {
  token: string | null;
  user: unknown;
  login: (email: string, password: string) => Promise<void>;
  register: (name: string, email: string, password: string) => Promise<void>;
  logout: () => void;
}

export let dispatchLogout: () => void = () => {};
export let dispatchSetUser: (user: unknown) => void = () => {};

const AuthContext = createContext<AuthContextProps | null>(null);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
  const [user, setUser] = useState<unknown>(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : null);
  const [loginMutation] = useMutation(LOGIN_MUTATION);
  const [registerMutation] = useMutation(REGISTER_MUTATION);

  useEffect(() => {
    dispatchSetUser = setUser;
  }, []);

  const login = async (email: string, password: string) => {
    const { data } = await loginMutation({ variables: { email, password } });
    const received = data?.login?.token;
    if (received) {
      setToken(received);
      localStorage.setItem('token', received);
      localStorage.setItem('user', JSON.stringify(data.login.usuario));
      setUser(data.login.usuario);
    }
  };

  const register = async (name: string, email: string, password: string) => {
    const { data } = await registerMutation({ variables: { name, email, password } });
    const received = data?.register?.token;
    if (received) {
      setToken(received);
      localStorage.setItem('token', received);
      localStorage.setItem('user', JSON.stringify(data.register.usuario));
      setUser(data.register.usuario);
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  dispatchLogout = logout;


  return (
    <AuthContext.Provider value={{ token, user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
